export const create = (initial = {}) => {
  let cacheData: Record<string, any> = { ...initial };
  return {
    get<T>(key: number): T | undefined {
      return cacheData[key] as T;
    },

    set(key: number, data: any) {
      cacheData[key] = data;
    },

    hydrate(cache: Record<string, any>) {
      Object.assign(cacheData, cache);
    },

    clearCache() {
      cacheData = {};
    },

    extract() {
      return cacheData;
    },
  } as const;
};

export type Cache = ReturnType<typeof create>;
